/**
 * 管理员静态菜单配置
 */
export const MenuConfig: MenuItem[] = [
  // 教职工管理
  {
    path: 'usersManage',
    name: 'UserManage',
    roles: ['SYSTEM_ADMIN', 'ADMIN'],
    meta: {
      title: '用户管理',
      icon: 'Avatar',
      sort: 2,
      affix: true,
      breadcrumb: true,
    },
    children: [
      {
        path: 'userInfo',
        name: 'userInfo',
        component: '/admin/users/info/index',
        meta: {
          title: '用户信息',
          icon: 'Postcard',
          affix: true,
          sort: 1,
        },
      },
      {
        path: 'importUsers',
        name: 'importUser',
        component: '/admin/uploadFile/index',
        roles: ['SYSTEM_ADMIN'],
        meta: {
          title: '导入教职工信息',
          icon: 'UploadFilled',
          sort: 2,
          keepAlive: true,
        },
      },
    ],
  },
  // 招生任务管理
  {
    path: 'admissionTaskManage',
    name: 'admissionTaskManage',
    roles: ['SYSTEM_ADMIN', 'ADMIN', 'TEACHER'],
    meta: {
      title: '县内招生管理',
      icon: 'School',
      sort: 3,
      alwaysShow: true,
    },
    children: [
      {
        path: 'admissionTaskInfo',
        name: 'admissionTaskInfo',
        component: '/admin/admissionTask/info/index',
        meta: {
          title: '县内招生安排',
          icon: 'Postcard',
          sort: 1,
        },
      },
      {
        path: 'importTask',
        name: 'importTask',
        component: '/admin/uploadFile/index',
        roles: ['SYSTEM_ADMIN'],
        meta: {
          title: '导入县内招生安排',
          icon: 'UploadFilled',
          sort: 2,
          keepAlive: true,
        },
      },
    ],
  },
  // 收费标准
  {
    path: 'expenseManage',
    name: 'expenseManage',
    meta: {
      title: '收费标准管理',
      icon: 'OfficeBuilding',
      sort: 4,
      alwaysShow: true,
    },
    roles: ['SYSTEM_ADMIN', 'ADMIN'],
    children: [
      {
        path: 'basicExpense',
        name: 'basicExpense',
        component: '/admin/expense/basicExpense/index',
        meta: {
          title: '资料费及保证金',
          icon: 'Tickets',
          sort: 1,
        },
      },
      {
        path: 'expenseInfo',
        name: 'expenseInfo',
        component: '/admin/expense/info/index',
        meta: {
          title: '收费标准',
          icon: 'Postcard',
          sort: 2,
        },
      },
      {
        path: 'discountInfo',
        name: 'discountInfo',
        component: '/admin/expense/discountInfo/index',
        roles: ['SYSTEM_ADMIN', 'ADMIN'],
        meta: {
          title: '优惠政策',
          icon: 'Postcard',
          sort: 3,
        },
      },
      {
        path: 'importExpense',
        name: 'importExpense',
        component: '/admin/uploadFile/index',
        roles: ['SYSTEM_ADMIN'],
        meta: {
          title: '导入收费标准',
          icon: 'UploadFilled',
          sort: 4,
        },
      },
    ],
  },
  // 学生信息管理
  {
    path: 'studentsManage',
    name: 'studentsManage',
    roles: ['SYSTEM_ADMIN', 'ADMIN'],
    meta: {
      title: '学生信息管理',
      icon: 'UserFilled',
      sort: 4,
      breadcrumb: true,
      alwaysShow: true,
    },
    children: [
      {
        path: 'studentsInfo',
        name: 'studentsInfo',
        component: '/public/studentsInfo/index',
        meta: {
          title: '学生信息',
          icon: 'Postcard',
          sort: 1,
        },
      },
      {
        path: 'admissionStatistic',
        name: 'admissionStatistic',
        component: '/public/statistic/index',
        meta: {
          title: '数据统计',
          icon: 'PieChart',
          affix: true,
          sort: 2,
        },
      },
      {
        path: 'importStudents',
        name: 'importStudents',
        component: '/admin/uploadFile/index',
        roles: ['SYSTEM_ADMIN'],
        meta: {
          title: '导入学生信息',
          icon: 'UploadFilled',
          sort: 3,
        },
      },
    ],
  },
  // 我的课时
  {
    path: 'admission',
    name: 'admission',
    roles: ['TEACHER'],
    meta: {
      title: '我的招生',
      icon: 'Grid',
      sort: 9,
      affix: true,
      breadcrumb: true,
    },
    children: [
      {
        path: 'students',
        name: 'students',
        component: '/public/studentsInfo/index',
        meta: {
          title: '我的学生信息',
          icon: 'Postcard',
          affix: true,
          sort: 1,
        },
      },
      {
        path: 'statistic',
        name: 'statistic',
        component: '/public/statistic/index',
        meta: {
          title: '我的数据统计',
          icon: 'PieChart',
          affix: true,
          sort: 2,
        },
      },
    ],
  },
  // 审核管理
  {
    path: 'reviewManage',
    name: 'reviewManage',
    roles: ['REVIEWER'],
    meta: {
      title: '审核管理',
      icon: 'Avatar',
      sort: 8,
      affix: true,
      breadcrumb: true,
    },
    children: [
      {
        path: 'PendingReview',
        name: 'PendingReview',
        component: '/users/review/index',
        meta: {
          title: '报名审核',
          icon: 'Postcard',
          affix: true,
          sort: 1,
        },
      },
    ],
  },
  // 系统管理
  {
    path: 'systemManage',
    name: 'systemManage',
    roles: ['SYSTEM_ADMIN'],
    meta: {
      title: '系统管理',
      icon: 'Setting',
      sort: 10,
    },
    children: [
      {
        path: 'systemSetting',
        name: 'systemSetting',
        component: '/admin/system/info/index',
        meta: {
          title: '系统设置',
          icon: 'Setting',
          sort: 1,
        },
      },
      {
        path: 'backup',
        name: 'back',
        component: '/admin/system/tables/index',
        meta: {
          title: '数据库备份',
          icon: 'Coin',
          sort: 2,
        },
      },
    ],
  },
]
